import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.7074 3.2929c.3906-.3905 1.0237-.3905 1.4143 0l8 8c.3905.3905.3905 1.0237 0 1.4142l-8 8c-.3906.3905-1.0237.3905-1.4143 0l-1-1c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4143 0l.2929.2929L21.0003 12l-6.5857-6.5858-.2929.293c-.3906.3904-1.0237.3904-1.4143 0-.3905-.3906-.3905-1.0238 0-1.4143z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M8.7074 4.293c.3906-.3905 1.0237-.3905 1.4143 0l7.0002 7.0002c.3905.3906.3905 1.0237 0 1.4143l-7.0002 7.0002c-.3906.3905-1.0237.3905-1.4143 0l-7.0002-7.0002c-.3905-.3906-.3905-1.0237 0-1.4143zm.7072 2.1214-5.586 5.586 5.586 5.5859 5.5859-5.5859z",
        clipRule: "evenodd"
    }, "1")
], "AudienceLookalike", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
